// extracted by mini-css-extract-plugin
export var closeButton = "_am-0";